module.exports = "<div class=\"capeRedirect\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/redirect-to-cape/template.html
// module id = ./components/xo-credit-components/src/redirect-to-cape/template.html
// module chunks = 1